import isNumber from 'lodash/isNumber';
import isString from 'lodash/isString';

import { defaultSize, Size, SizeType, SizeValue } from './types';

export const sizeTypeToString = (sizeType: SizeType) => {
  if (sizeType === SizeType.Percentage) {
    return '%';
  }
  if (sizeType === SizeType.Pixel) {
    return 'px';
  }

  return sizeType;
};
export const px = (n?: number) => (typeof n !== 'undefined' ? `${n}px` : `unset`);
export const percent = (p?: number) => (typeof p !== 'undefined' ? `${p}%` : `unset`);

const tryToParseValue = (type: SizeType, value: string): { type: SizeType; value: SizeValue } => {
  const parsed = parseInt(value, 10);
  if (!Number.isNaN(parsed)) {
    return { type, value: parsed };
  }
  return { type: SizeType.Default, value: undefined };
};

const parseRecord = (record?: string | number): { type: SizeType; value: SizeValue } => {
  if (record === SizeType.Auto) {
    return { type: SizeType.Auto, value: undefined };
  }
  if (!record || (!isNumber(record) && !isString(record))) {
    return { type: SizeType.Default, value: undefined };
  }
  if (isNumber(record)) {
    return { type: SizeType.Percentage, value: record };
  }
  if (record.indexOf('px') > 0) {
    return tryToParseValue(SizeType.Pixel, record.replace('px', ''));
  }
  return tryToParseValue(SizeType.Percentage, record.replace('%', ''));
};

export const getSizeValues = (record: Record<string, string | number> = {}): Size => {
  const parsedWidth = parseRecord(record.width);
  const parsedHeight = parseRecord(record.height);
  return { width: parsedWidth, height: parsedHeight };
};

export const writeValue = (size: { type: SizeType; value?: SizeValue } | undefined) => {
  if (!size) {
    return undefined;
  }
  const { type, value } = size;

  if (type === SizeType.Auto && typeof value === 'undefined') {
    return SizeType.Auto;
  }
  if (value === SizeType.Default || typeof value === 'undefined') {
    return undefined;
  }

  const writeFunction = type === SizeType.Pixel ? px : percent;
  return writeFunction(value);
};

export const setSizeValues = (size: Size = defaultSize): Record<string, string | undefined> => {
  const { height = defaultSize.height, width = defaultSize.width } = size;
  return { width: writeValue(width), height: writeValue(height) };
};
